'use client';

import useProduct from '@/contexts/ProductProvider';
import { ArrayHasValue } from '@/services/ecommerce/utils/helper';
import Attributes from '../Attributes';

const WrapperAttributes = ({ data }: any) => {
	const { selectedVariant, selectedAttributes, setSelectedAttributes, product } = useProduct();

	const onVariantClick = (title = '', value = '') => {
		setSelectedAttributes((prev) => ({
			...prev,
			[title]: value
		}));
	};

	return (
		<>
			{ArrayHasValue(data.p_attribute) && (
				<div className=' border-t1-grey300'>
					{data.p_attribute?.map((item: any, i: any) => (
						<Attributes
							key={i}
							item={item}
							onVariantClick={onVariantClick}
							selectedAttributes={selectedAttributes}
							product={product}
							selectedVariant={selectedVariant}
						/>
					))}
				</div>
			)}
		</>
	);
};

export default WrapperAttributes;
